import axios from "axios";
// import { BASE_URL_NODE } from "../../config";

export const IndiaLoginApi = async (formdata) => {
  return await axios.get(
    `https://dev-sahaj-ttp-be.artofliving.org/india_login/${formdata?.name}/${formdata?.pass}`
  );
};
